import { render, staticRenderFns } from "./BoardDisplay.vue?vue&type=template&id=9bc084fe&"
import script from "./BoardDisplay.vue?vue&type=script&lang=js&"
export * from "./BoardDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports